import { useSelector, useDispatch } from "react-redux";
import { clear_error_boundary } from "../../App/actions/errorBoundaryActions";
/* FIXED: Use useNavigate instead of useHistory and fix the import path */
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// image

function ErrorUIBoundary() {
  /* FIXED: Initialize useNavigate hook */
  const navigate = useNavigate();
  const error_boundary = useSelector((state) => state.error_boundary);
  const dispatch = useDispatch();
  const prevPathname = useSelector((state) => state.auth.previous_pathname);
  const [frozenPrevPath, setFrozenPrevPath] = useState(null);
  const [isDetailErrorModal, setIsDetailErrorModal] = useState(false);

  const onRedirect = () => {
    dispatch(clear_error_boundary());
    if (frozenPrevPath) {
      navigate(frozenPrevPath);
    } else {
      navigate("/");
    }
  };

  const onClickErrorDetailModal = () => {
    setIsDetailErrorModal(!isDetailErrorModal);
  };

  useEffect(() => {
    if (Object.keys(error_boundary).length > 0 && !frozenPrevPath) {
      setFrozenPrevPath(prevPathname);
    }
  }, [error_boundary, prevPathname, frozenPrevPath]);

  const isEmpty = Object.keys(error_boundary).length;
  if (isEmpty === 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: ".5rem",
        }}
      >
        <img
          src="https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/mapid_error_graphic.png"
          alt="Not Found"
          width={"350rem"}
          style={{ marginBottom: "1rem" }}
        />
        {isDetailErrorModal ? (
          <ErrorDetailModal
            name={error_boundary?.message?.name}
            message={error_boundary?.message?.message}
            stack={error_boundary?.message?.stack}
          />
        ) : (
          <>
            <h1>Error</h1>
            <p
              style={{
                width: "19rem",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Something went wrong.
            </p>
          </>
        )}
        <button className="button background_red" onClick={onRedirect}>
          Kembali
        </button>
        <button
          className="button background_black"
          onClick={onClickErrorDetailModal}
        >
          Detail Error
        </button>
      </div>
    </div>
  );
}

function ErrorDetailModal(props) {
  const { name, message, stack } = props;
  const errorString = "Error: ";
  const avoidStringLength = message?.length + errorString?.length;
  const newStack = stack?.slice(avoidStringLength);
  const stackArray = newStack?.split(" at ");
  stackArray?.shift();

  return (
    <div
      className="container_notification"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: ".3rem",
        maxWidth: "30rem",
        height: "10rem",
        padding: "1rem",
        overflowY: "scroll",
        scrollbarWidth: "thin",
        zIndex: 1500,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: ".5rem",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{name}</p>
        <p style={{ textAlign: "left", fontSize: ".9rem" }}>{message}</p>
        {stackArray?.map((text, index) => (
          <p
            key={index}
            style={{
              textAlign: "left",
              lineHeight: 2,
              paddingLeft: "2rem",
              fontSize: ".7rem",
            }}
            className="text_grey"
          >
            at {text}
          </p>
        ))}
      </div>
    </div>
  );
}

export default ErrorUIBoundary;
